































import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import CheckboxBase from '@/components/common/atoms/CheckboxBase.vue'
import { TeacherForBranchData } from '@/mixins/requests/academy/TeacherForBranchApis.vue'

@Component({
  components: {
    ButtonBase,
    CheckboxBase,
  },
})
export default class TeacherForBranchTable extends Vue {
  @Prop()
  private teacherForBranchList!: TeacherForBranchData[]
  @Prop()
  private onClickNicknameUpdateButton!: (bcbtCode: string) => void
  @Prop()
  private onClickPasswordUpdateButton!: (bcbtCode: string) => void
  @Prop()
  private onClickDeleteButton!: (bcbtCode: string) => void

  /**
   * 教室長チェック
   */
  private onCheckIsManager(bcbtCode: string, checked: boolean) {
    this.$emit('check-manager', bcbtCode, checked)
  }
}
